<template>
  <v-container fluid fill-height align-start pa-0 class="notice pageWrap">
    <v-sheet class="contents-container">
      <v-sheet class="w-full">
        <i-card-vertical headerTitle="공지사항" device="multi">
          <template v-slot:body>
            <DxDataGrid
              id="NoticeGrid"
              class="layout-col-height00"
              width="100%"
              :ref="dxDataGridRef"
              :data-source="gridMain"
              :remote-operations="false"
              :hover-state-enabled="true"
              :allow-column-resizing="true"
              :allow-column-reordering="true"
              :row-alternation-enabled="true"
              :column-auto-width="false"
              :column-auto-height="true"
              :show-borders="true"
              :show-row-lines="true"
              :column-hiding-enabled="false"
              :focused-row-enabled="true"
              :selection="{ mode: 'single' }"
              key-expr="uniqueKey"
              @editing-start="onEditingStart"
              @cell-prepared="onCellPrepared"
              @editor-preparing="
                (e) => {
                  onEditorPreparing(e)
                  dispDateSetting(e)
                }
              "
            >
              <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

              <DxSelection select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

              <DxColumn data-field="clntId" data-type="string" :visible="false"></DxColumn>
              <DxColumn data-field="docNo" data-type="string" :visible="false"></DxColumn>
              <DxColumn data-field="writeDt" data-type="string" :visible="false"></DxColumn>
              <!-- <DxColumn data-field="seq" data-type="number" :visible="false"> </DxColumn> -->
              <DxColumn
                data-field="save"
                data-type="string"
                width="120px"
                alignment="center"
                caption
                :allow-editing="false"
                cell-template="actionTemplete"
              ></DxColumn>
              <template #actionTemplete="{ data: cellInfo }">
                <v-btn color="primary" small elevation="0" dark @click="btnDetail(cellInfo)" class="rounded px-3 grid-btn">상세보기</v-btn>
              </template>
              <DxColumn
                id="product1"
                data-field="subject"
                caption="제목"
                data-type="string"
                :min-width="200"
                alignment="left"
                :editorOptions="{ maxLength: 180 }"
                :allow-sorting="false"
                :allow-editing="false"
                css-class="devest-grid-header-require"
              ></DxColumn>
              <DxColumn
                id="noticeTypeNm"
                data-field="noticeTypeNm"
                caption="공지타입"
                data-type="string"
                width="120px"
                alignment="center"
                :allow-sorting="false"
                :allow-editing="false"
              ></DxColumn>

              <DxColumn data-field="userNm" caption="작성자" width="120px" data-type="string" alignment="center" :allow-editing="false"></DxColumn>

              <DxColumn data-field="createdAt" caption="작성일" width="120px" data-type="string" alignment="center" :allow-editing="false"></DxColumn>

              <DxColumn
                data-field="dispStDate"
                caption="게시시작일"
                width="100px"
                data-type="string"
                cell-template="readDate"
                edit-cell-template="writeDate"
                alignment="center"
                css-class="devest-grid-header-require"
                :allow-sorting="false"
                :allow-editing="false"
                :visible="false"
              ></DxColumn>

              <DxColumn
                data-field="dispEdDate"
                caption="게시종료일"
                width="100px"
                data-type="string"
                cell-template="readDate"
                edit-cell-template="writeDate"
                alignment="center"
                :allow-sorting="false"
                :allow-editing="false"
                :visible="false"
              ></DxColumn>
              <template #readDate="{ data: cellInfo }">
                <div>{{ cellInfo.displayValue }}</div>
              </template>
              <template #writeDate="{ data: cellInfo }">
                <div>
                  <DxDateBox
                    :value="cellInfo.value"
                    type="date"
                    picker-type="calendar"
                    display-format="yyyy.MM.dd"
                    :use-mask-behavior="true"
                    :allow-sorting="false"
                    :visible="false"
                  />
                </div>
              </template>
            </DxDataGrid>
          </template>
        </i-card-vertical>
      </v-sheet>

      <v-sheet class="iCardRightWrap">
        <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch()" @btnAdd="btnAdd()" @btnDelete="btnDelete()"></i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import { deleteNotice, getNotice } from '@/api/board/notice/notice'
import { deleteFiles, getFile } from '@/api/baseManage/fileUpload'
import { getCommonCode } from '@/api/common/commonApi'
import iCardTop from '@/components/common/iCardTop.vue'
import iCardRight from '@/components/common/iCardRight.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import IDxPopup from '@/components/common/iDxPopup.vue'
import IFileUpload from '@/components/common/iFileUpload.vue'
import { AesDecrypt } from '@/utils/aes256'
import { getCurrentDate } from '@/utils/common.js'
import { getUserCd } from '@/utils/token'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import { DxColumn, DxDataGrid, DxEditing, DxSelection } from 'devextreme-vue/data-grid'
import { DxPopover } from 'devextreme-vue/popover'
import DxDateBox from 'devextreme-vue/date-box'
import { getGrpAuthCd } from '@/utils/token'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxEditing,
    DxPopover,
    'i-card-vertical': iCardVertical,
    'i-card-top': iCardTop,
    'i-card-right': iCardRight,
    IDxPopup,
    DxDateBox,
    IFileUpload,
    // 절차서 컴포넌트
  },
  data() {
    return {
      dxDataGridRef: 'NoticeGrid',
      gridMain: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnDelete', //삭제
      ],
      dxFileUploaderRef: 'uploaderContainer',
      fileData: {},
      currentCellInfo: null,
      // file popup
      popupData: {},
      popupVisible: false,
      noticeTypeList: [],
      clntId: '',
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
    }
  },
  beforeMount() {
    this.BaseInitialize()
    this.datagridRefs = [this.dxDataGridRef]
    Promise.all([
      getCommonCode('CM011'), //(majorCd:CM011,majorNm:공지사항중요도)
    ]).then((res) => {
      // console.log(':##Re', res)
      this.noticeTypeList = res[0].list
    })
  },
  mounted() {},

  computed: {},
  activated() {
    //console.log('this.$route.params.focusedRowKey', this.$route.params.focusedRowKey)
    this.btnSearch()
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true,
      })
      const toRouter = {
        name: 'NoticeDetail',
        params: {
          data: data,
        },
      }
      this.$router.push(toRouter)
    },
    async btnDetail(cellInfo) {
      const toRouter = {
        name: 'NoticeDetail',
        params: {
          data: cellInfo.data,
        },
      }
      this.$router.push(toRouter)
    },
    btnSearch() {
      const grpAuthCd = getGrpAuthCd()
      // if (grpAuthCd === 'master' || grpAuthCd === 'kiest_admin') this.clntId = this.getClntId()
      const params = { clntId: this.getClntId() }

      return new Promise((resolve, reject) => {
        this.gridMain = []
        this.openLoading()

        getNotice(params, true)
          .then((res) => {
            if (res.success) {
              // this.gridMain = res.list
              this.gridMain = res.list.map((item, index) => ({
                ...item,
                uniqueKey: `${item.docNo}${item.clntId}${item.writeDt}${index}`, // 새로운 키 값 생성
              }))
              this.endLoading()

              this.gridInit(this.DataGrids[0])
              this.FocusFirstRow(this.DataGrids[0])
              resolve(true)
              //this.DataGrids[0].option('focusedRowIndex', 0)
            }
          })
          .catch((e) => {
            this.endLoading()
          })
          .finally(() => {})
      })
    },

    async btnDelete() {
      var selectedRows = await this.DataGrids[0].getSelectedRowsData()
      if (selectedRows.length === 0) {
        // this.$vToastify.warning({ body: this.$t('selectionData') })
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.vToastifyPrompt(this.$t('doDeleteData'), 'info', (current) => {
        this.openLoading()
        //this.DataGrids[0].beginUpdate()
        this.DataGrids[0].saveEditData()
        console.log(selectedRows)
        deleteNotice(selectedRows, true)
          .then((res) => {
            selectedRows.forEach((el) => {
              let searchParams = {
                targetId: `${el.clntId}_${el.writeDt}_${el.docNo}`,
                targetType: '00002',
                clntId: el.clntId,
              }
              getFile(searchParams, false).then((res) => {
                deleteFiles(res.list, true)
                  .then((res) => {
                    if (res.success) {
                      this.endLoading()
                    }
                  })
                  .finally(() => {
                    this.endLoading()
                  })
              })
            })
            //            this.btnSearch()
          })
          .catch((e) => {
            this.endLoading()
          })
          .finally(() => {
            this.deleteCallBack(selectedRows)
          })
      })
    },

    ///////////////////////////////////////
    /*        DataGrid Event Event       */
    ///////////////////////////////////////
    //행 cell에서 데이터 수정후 저장을 누르면 선택된 데이터가 없다는 메세지가 발생
    //위 문제를 해결하기 위해서 아래 소스코드 구현

    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach((key) => {
        index = this.gridMain.findIndex((obj) => obj == key)
        this.gridMain.splice(index, 1)
      })
    },
    //추가된 행이 아니면 수정 불가능하게 설정
    onEditingStart(e) {
      // if (e.column.dataField == 'workPlaceId' && !e.data.__created__) e.cancel = true
      // else e.cancel = false
    },
    dispDateSetting(e) {
      if (e.parentType == 'dataRow') {
        if (e.dataField == 'dispStDate') {
          e.editorOptions.max = e.row.data.dispEdDate
        } else if (e.dataField == 'dispEdDate') {
          e.editorOptions.min = e.row.data.dispStDate
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.DataGrids[0].selectRows(cellInfo.row.key, true)
    },
    parseDate(element, isDisplay, type) {
      if (type == 1) {
        return element && isDisplay ? `${element.substring(0, 4)}.${element.substring(5, 7)}.${element.substring(8, 10)}` : ''
      }
      if (type == 2) {
        return element && isDisplay ? `${element.substring(0, 4)}.${element.substring(4, 6)}.${element.substring(6, 8)}` : ''
      }
    },
    onValueChanged(event, cellInfo) {
      //날짜 세팅
      const date = new Date(event.value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const dateFormat = `${year}.${month}.${day}`

      //그리드 삽입
      const cell = this.gridMain[cellInfo.rowIndex]
      cell[cellInfo.column.dataField] = dateFormat
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key)
    },
    onCheckValueChanged(value, cellInfo) {
      console.log('## ', value, cellInfo)
      // cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      // this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      // cellInfo.component.updateDimensions()
    },
    onCellPrepared(e) {
      if (e.rowType !== 'data') return
      const clntId = e.data?.clntId
      if (!clntId) return

      const highlightTargets = ['IGNS', '2409000008']
      if (highlightTargets.includes(clntId)) {
        e.cellElement?.classList.add('notice-blue-cell')
      } else {
        e.cellElement?.classList.remove('notice-blue-cell')
      }
    },
  },
}
</script>

<style lang="scss">
.dx-command-select {
  width: 30px !important;
  min-width: 30px !important;
}

// .dx-master-detail-row:not(.dx-datagrid-edit-form) .dx-master-detail-cell .dx-field-item-content {
//   height: auto;
// }

// .dx-texteditor-input,
// .dx-texteditor.dx-editor-outlined {
//   border-style: none;
// }

//
.header_name {
  margin-left: 2px;
  font-weight: bold;
  font-size: 0.75rem;
  color: #000;
}

.header_value {
  font-weight: bold;
  font-size: 0.75rem;
  color: #2196f3;
}

.fileInfo {
  display: contents;
}

.upload_icon {
  height: 30px !important;
  margin-top: 5px;
  margin-bottom: 5px;
}

.dx-master-detail-row .dx-row-focused .file_icon {
  color: #fff !important;
}

.notice-blue-cell {
  color: #1e88e5 !important;
}
</style>
